import axiosConfig from "../../../../../config/axiosConfig";
const CRT001Api = () => {
  const getCRT001Data = async (params: any): Promise<any> => {
    try {
      const url = "/project/summary-list-relate-money";
      const response = await axiosConfig.get(url, { params });
      return response;
    } catch (error) {
      throw error;
    }
  };

  return {
    getCRT001Data,
  };
};

export default CRT001Api;
